import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: "Organization Participant Config"})
export default class OrganizationParticipantConfig {

	@Input({type: InputType.CHECKBOX, title: "Show Org Icon"})
	public showIcon: boolean;

	@Input({type: InputType.CHECKBOX, title: "Show User Count"})
	public showUserCount: boolean;

}



// WEBPACK FOOTER //
// ./src/panels/organizationParticipant/OrganizationParticipantConfig.ts